/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as appRouteRouteImport } from "./routes/(app)/route"
import { Route as authRouteRouteImport } from "./routes/(auth)/route"
import { Route as LogoutRouteImport } from "./routes/logout"
import { Route as appIndexRouteImport } from "./routes/(app)/index"
import { Route as appWorkspaceRouteRouteImport } from "./routes/(app)/$workspace/route"
import { Route as appAdminRouteImport } from "./routes/(app)/admin"
import { Route as appWorkspaceCreateRouteImport } from "./routes/(app)/workspace-create"
import { Route as appWorkspaceSelectRouteImport } from "./routes/(app)/workspace-select"
import { Route as authAcceptInviteRouteImport } from "./routes/(auth)/accept-invite"
import { Route as authForgotPasswordRouteImport } from "./routes/(auth)/forgot-password"
import { Route as authLoginRouteImport } from "./routes/(auth)/login"
import { Route as authRegisterRouteImport } from "./routes/(auth)/register"
import { Route as authResetPasswordRouteImport } from "./routes/(auth)/reset-password"
import { Route as authResetPasswordSentRouteImport } from "./routes/(auth)/reset-password-sent"
import { Route as authVerifyEmailRouteImport } from "./routes/(auth)/verify-email"
import { Route as authVerifyEmailSentRouteImport } from "./routes/(auth)/verify-email-sent"
import { Route as appWorkspaceIndexRouteImport } from "./routes/(app)/$workspace/index"
import { Route as appWorkspaceSplatRouteImport } from "./routes/(app)/$workspace/$"
import { Route as appWorkspaceInboxRouteImport } from "./routes/(app)/$workspace/inbox"
import { Route as appWorkspaceMapRouteImport } from "./routes/(app)/$workspace/map"
import { Route as appWorkspaceMembersRouteImport } from "./routes/(app)/$workspace/members"
import { Route as appWorkspaceMyWorkRouteImport } from "./routes/(app)/$workspace/my-work"
import { Route as appWorkspaceOrgChartRouteImport } from "./routes/(app)/$workspace/org-chart"
import { Route as appWorkspaceSettingsRouteRouteImport } from "./routes/(app)/$workspace/settings/route"
import { Route as appWorkspaceSharedRouteImport } from "./routes/(app)/$workspace/shared"
import { Route as appWorkspaceTeamsRouteImport } from "./routes/(app)/$workspace/teams"
import { Route as appWorkspaceWorkflowsRouteImport } from "./routes/(app)/$workspace/workflows"
import { Route as appWorkspaceDashboardsIndexRouteImport } from "./routes/(app)/$workspace/dashboards/index"
import { Route as appWorkspaceDashboardsViewIdRouteImport } from "./routes/(app)/$workspace/dashboards/$viewId"
import { Route as appWorkspaceDashboardsMyRouteImport } from "./routes/(app)/$workspace/dashboards/my"
import { Route as appWorkspaceSettingsIndexRouteImport } from "./routes/(app)/$workspace/settings/index"
import { Route as appWorkspaceSettingsAppearanceRouteImport } from "./routes/(app)/$workspace/settings/appearance"
import { Route as appWorkspaceSettingsCustomFieldsRouteImport } from "./routes/(app)/$workspace/settings/custom-fields"
import { Route as appWorkspaceSettingsIssueSourcesRouteImport } from "./routes/(app)/$workspace/settings/issue-sources"
import { Route as appWorkspaceSettingsOutcomesRouteImport } from "./routes/(app)/$workspace/settings/outcomes"
import { Route as appWorkspaceSettingsPermissionsRouteImport } from "./routes/(app)/$workspace/settings/permissions"
import { Route as appWorkspaceSettingsPreferencesRouteImport } from "./routes/(app)/$workspace/settings/preferences"
import { Route as appWorkspaceSettingsProfileRouteImport } from "./routes/(app)/$workspace/settings/profile"
import { Route as appWorkspaceSettingsTrashRouteImport } from "./routes/(app)/$workspace/settings/trash"
import { Route as appWorkspaceSettingsUpdatesRouteImport } from "./routes/(app)/$workspace/settings/updates"
import { Route as appWorkspaceSettingsWorkspaceRouteImport } from "./routes/(app)/$workspace/settings/workspace"
import { Route as appWorkspaceTeamTeamIdRouteRouteImport } from "./routes/(app)/$workspace/team/$teamId/route"
import { Route as appWorkspaceWorkflowWorkflowIdRouteRouteImport } from "./routes/(app)/$workspace/workflow/$workflowId/route"
import { Route as appWorkspaceMemberMemberIdIndexRouteImport } from "./routes/(app)/$workspace/member/$memberId/index"
import { Route as appWorkspaceSettingsAccessIndexRouteImport } from "./routes/(app)/$workspace/settings/access/index"
import { Route as appWorkspaceSettingsAccessCreateRouteImport } from "./routes/(app)/$workspace/settings/access/create"
import { Route as appWorkspaceSettingsApiIndexRouteImport } from "./routes/(app)/$workspace/settings/api/index"
import { Route as appWorkspaceSettingsIssueTypesIndexRouteImport } from "./routes/(app)/$workspace/settings/issue-types/index"
import { Route as appWorkspaceSettingsIssueTypesIssueTypeIdRouteImport } from "./routes/(app)/$workspace/settings/issue-types/$issueTypeId"
import { Route as appWorkspaceSettingsMembersIndexRouteImport } from "./routes/(app)/$workspace/settings/members/index"
import { Route as appWorkspaceSettingsMembersUserIdRouteImport } from "./routes/(app)/$workspace/settings/members/$userId"
import { Route as appWorkspaceSettingsTeamsIndexRouteImport } from "./routes/(app)/$workspace/settings/teams/index"
import { Route as appWorkspaceSettingsWorkflowsIndexRouteImport } from "./routes/(app)/$workspace/settings/workflows/index"
import { Route as appWorkspaceTeamTeamIdIndexRouteImport } from "./routes/(app)/$workspace/team/$teamId/index"
import { Route as appWorkspaceTeamTeamIdBoardRouteImport } from "./routes/(app)/$workspace/team/$teamId/board"
import { Route as appWorkspaceTeamTeamIdChartRouteImport } from "./routes/(app)/$workspace/team/$teamId/chart"
import { Route as appWorkspaceTeamTeamIdListRouteImport } from "./routes/(app)/$workspace/team/$teamId/list"
import { Route as appWorkspaceTeamTeamIdMembersRouteImport } from "./routes/(app)/$workspace/team/$teamId/members"
import { Route as appWorkspaceTeamTeamIdOverviewRouteImport } from "./routes/(app)/$workspace/team/$teamId/overview"
import { Route as appWorkspaceWorkflowWorkflowIdIndexRouteImport } from "./routes/(app)/$workspace/workflow/$workflowId/index"
import { Route as appWorkspaceWorkflowWorkflowIdBoardRouteImport } from "./routes/(app)/$workspace/workflow/$workflowId/board"
import { Route as appWorkspaceWorkflowWorkflowIdDashboardRouteImport } from "./routes/(app)/$workspace/workflow/$workflowId/dashboard"
import { Route as appWorkspaceWorkflowWorkflowIdListRouteImport } from "./routes/(app)/$workspace/workflow/$workflowId/list"
import { Route as appWorkspaceSettingsAccessApiKeyIdIndexRouteImport } from "./routes/(app)/$workspace/settings/access/$apiKeyId/index"
import { Route as appWorkspaceSettingsAccessApiKeyIdEditRouteImport } from "./routes/(app)/$workspace/settings/access/$apiKeyId/edit"
import { Route as appWorkspaceSettingsApiKeysCreateRouteImport } from "./routes/(app)/$workspace/settings/api/keys/create"
import { Route as appWorkspaceSettingsApiWebhooksCreateRouteImport } from "./routes/(app)/$workspace/settings/api/webhooks/create"
import { Route as appWorkspaceSettingsTeamsTeamIdIndexRouteImport } from "./routes/(app)/$workspace/settings/teams/$teamId/index"
import { Route as appWorkspaceSettingsWorkflowsWorkflowIdIndexRouteImport } from "./routes/(app)/$workspace/settings/workflows/$workflowId/index"
import { Route as appWorkspaceWorkflowWorkflowIdViewViewIdRouteImport } from "./routes/(app)/$workspace/workflow/$workflowId/view/$viewId"
import { Route as appWorkspaceSettingsApiKeysApiKeyIdIndexRouteImport } from "./routes/(app)/$workspace/settings/api/keys/$apiKeyId/index"
import { Route as appWorkspaceSettingsApiKeysApiKeyIdEditRouteImport } from "./routes/(app)/$workspace/settings/api/keys/$apiKeyId/edit"
import { Route as appWorkspaceSettingsApiWebhooksWebhookIdIndexRouteImport } from "./routes/(app)/$workspace/settings/api/webhooks/$webhookId/index"
import { Route as appWorkspaceSettingsApiWebhooksWebhookIdEditRouteImport } from "./routes/(app)/$workspace/settings/api/webhooks/$webhookId/edit"

const appRouteRoute = appRouteRouteImport.update({
  id: "/(app)",
  getParentRoute: () => rootRouteImport,
} as any)
const authRouteRoute = authRouteRouteImport.update({
  id: "/(auth)",
  getParentRoute: () => rootRouteImport,
} as any)
const LogoutRoute = LogoutRouteImport.update({
  id: "/logout",
  path: "/logout",
  getParentRoute: () => rootRouteImport,
} as any)
const appIndexRoute = appIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => appRouteRoute,
} as any)
const appWorkspaceRouteRoute = appWorkspaceRouteRouteImport.update({
  id: "/$workspace",
  path: "/$workspace",
  getParentRoute: () => appRouteRoute,
} as any)
const appAdminRoute = appAdminRouteImport.update({
  id: "/admin",
  path: "/admin",
  getParentRoute: () => appRouteRoute,
} as any)
const appWorkspaceCreateRoute = appWorkspaceCreateRouteImport.update({
  id: "/workspace-create",
  path: "/workspace-create",
  getParentRoute: () => appRouteRoute,
} as any)
const appWorkspaceSelectRoute = appWorkspaceSelectRouteImport.update({
  id: "/workspace-select",
  path: "/workspace-select",
  getParentRoute: () => appRouteRoute,
} as any)
const authAcceptInviteRoute = authAcceptInviteRouteImport.update({
  id: "/accept-invite",
  path: "/accept-invite",
  getParentRoute: () => authRouteRoute,
} as any)
const authForgotPasswordRoute = authForgotPasswordRouteImport.update({
  id: "/forgot-password",
  path: "/forgot-password",
  getParentRoute: () => authRouteRoute,
} as any)
const authLoginRoute = authLoginRouteImport.update({
  id: "/login",
  path: "/login",
  getParentRoute: () => authRouteRoute,
} as any)
const authRegisterRoute = authRegisterRouteImport.update({
  id: "/register",
  path: "/register",
  getParentRoute: () => authRouteRoute,
} as any)
const authResetPasswordRoute = authResetPasswordRouteImport.update({
  id: "/reset-password",
  path: "/reset-password",
  getParentRoute: () => authRouteRoute,
} as any)
const authResetPasswordSentRoute = authResetPasswordSentRouteImport.update({
  id: "/reset-password-sent",
  path: "/reset-password-sent",
  getParentRoute: () => authRouteRoute,
} as any)
const authVerifyEmailRoute = authVerifyEmailRouteImport.update({
  id: "/verify-email",
  path: "/verify-email",
  getParentRoute: () => authRouteRoute,
} as any)
const authVerifyEmailSentRoute = authVerifyEmailSentRouteImport.update({
  id: "/verify-email-sent",
  path: "/verify-email-sent",
  getParentRoute: () => authRouteRoute,
} as any)
const appWorkspaceIndexRoute = appWorkspaceIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => appWorkspaceRouteRoute,
} as any)
const appWorkspaceSplatRoute = appWorkspaceSplatRouteImport.update({
  id: "/$",
  path: "/$",
  getParentRoute: () => appWorkspaceRouteRoute,
} as any)
const appWorkspaceInboxRoute = appWorkspaceInboxRouteImport.update({
  id: "/inbox",
  path: "/inbox",
  getParentRoute: () => appWorkspaceRouteRoute,
} as any)
const appWorkspaceMapRoute = appWorkspaceMapRouteImport.update({
  id: "/map",
  path: "/map",
  getParentRoute: () => appWorkspaceRouteRoute,
} as any)
const appWorkspaceMembersRoute = appWorkspaceMembersRouteImport.update({
  id: "/members",
  path: "/members",
  getParentRoute: () => appWorkspaceRouteRoute,
} as any)
const appWorkspaceMyWorkRoute = appWorkspaceMyWorkRouteImport.update({
  id: "/my-work",
  path: "/my-work",
  getParentRoute: () => appWorkspaceRouteRoute,
} as any)
const appWorkspaceOrgChartRoute = appWorkspaceOrgChartRouteImport.update({
  id: "/org-chart",
  path: "/org-chart",
  getParentRoute: () => appWorkspaceRouteRoute,
} as any)
const appWorkspaceSettingsRouteRoute =
  appWorkspaceSettingsRouteRouteImport.update({
    id: "/settings",
    path: "/settings",
    getParentRoute: () => appWorkspaceRouteRoute,
  } as any)
const appWorkspaceSharedRoute = appWorkspaceSharedRouteImport.update({
  id: "/shared",
  path: "/shared",
  getParentRoute: () => appWorkspaceRouteRoute,
} as any)
const appWorkspaceTeamsRoute = appWorkspaceTeamsRouteImport.update({
  id: "/teams",
  path: "/teams",
  getParentRoute: () => appWorkspaceRouteRoute,
} as any)
const appWorkspaceWorkflowsRoute = appWorkspaceWorkflowsRouteImport.update({
  id: "/workflows",
  path: "/workflows",
  getParentRoute: () => appWorkspaceRouteRoute,
} as any)
const appWorkspaceDashboardsIndexRoute =
  appWorkspaceDashboardsIndexRouteImport.update({
    id: "/dashboards/",
    path: "/dashboards/",
    getParentRoute: () => appWorkspaceRouteRoute,
  } as any)
const appWorkspaceDashboardsViewIdRoute =
  appWorkspaceDashboardsViewIdRouteImport.update({
    id: "/dashboards/$viewId",
    path: "/dashboards/$viewId",
    getParentRoute: () => appWorkspaceRouteRoute,
  } as any)
const appWorkspaceDashboardsMyRoute =
  appWorkspaceDashboardsMyRouteImport.update({
    id: "/dashboards/my",
    path: "/dashboards/my",
    getParentRoute: () => appWorkspaceRouteRoute,
  } as any)
const appWorkspaceSettingsIndexRoute =
  appWorkspaceSettingsIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => appWorkspaceSettingsRouteRoute,
  } as any)
const appWorkspaceSettingsAppearanceRoute =
  appWorkspaceSettingsAppearanceRouteImport.update({
    id: "/appearance",
    path: "/appearance",
    getParentRoute: () => appWorkspaceSettingsRouteRoute,
  } as any)
const appWorkspaceSettingsCustomFieldsRoute =
  appWorkspaceSettingsCustomFieldsRouteImport.update({
    id: "/custom-fields",
    path: "/custom-fields",
    getParentRoute: () => appWorkspaceSettingsRouteRoute,
  } as any)
const appWorkspaceSettingsIssueSourcesRoute =
  appWorkspaceSettingsIssueSourcesRouteImport.update({
    id: "/issue-sources",
    path: "/issue-sources",
    getParentRoute: () => appWorkspaceSettingsRouteRoute,
  } as any)
const appWorkspaceSettingsOutcomesRoute =
  appWorkspaceSettingsOutcomesRouteImport.update({
    id: "/outcomes",
    path: "/outcomes",
    getParentRoute: () => appWorkspaceSettingsRouteRoute,
  } as any)
const appWorkspaceSettingsPermissionsRoute =
  appWorkspaceSettingsPermissionsRouteImport.update({
    id: "/permissions",
    path: "/permissions",
    getParentRoute: () => appWorkspaceSettingsRouteRoute,
  } as any)
const appWorkspaceSettingsPreferencesRoute =
  appWorkspaceSettingsPreferencesRouteImport.update({
    id: "/preferences",
    path: "/preferences",
    getParentRoute: () => appWorkspaceSettingsRouteRoute,
  } as any)
const appWorkspaceSettingsProfileRoute =
  appWorkspaceSettingsProfileRouteImport.update({
    id: "/profile",
    path: "/profile",
    getParentRoute: () => appWorkspaceSettingsRouteRoute,
  } as any)
const appWorkspaceSettingsTrashRoute =
  appWorkspaceSettingsTrashRouteImport.update({
    id: "/trash",
    path: "/trash",
    getParentRoute: () => appWorkspaceSettingsRouteRoute,
  } as any)
const appWorkspaceSettingsUpdatesRoute =
  appWorkspaceSettingsUpdatesRouteImport.update({
    id: "/updates",
    path: "/updates",
    getParentRoute: () => appWorkspaceSettingsRouteRoute,
  } as any)
const appWorkspaceSettingsWorkspaceRoute =
  appWorkspaceSettingsWorkspaceRouteImport.update({
    id: "/workspace",
    path: "/workspace",
    getParentRoute: () => appWorkspaceSettingsRouteRoute,
  } as any)
const appWorkspaceTeamTeamIdRouteRoute =
  appWorkspaceTeamTeamIdRouteRouteImport.update({
    id: "/team/$teamId",
    path: "/team/$teamId",
    getParentRoute: () => appWorkspaceRouteRoute,
  } as any)
const appWorkspaceWorkflowWorkflowIdRouteRoute =
  appWorkspaceWorkflowWorkflowIdRouteRouteImport.update({
    id: "/workflow/$workflowId",
    path: "/workflow/$workflowId",
    getParentRoute: () => appWorkspaceRouteRoute,
  } as any)
const appWorkspaceMemberMemberIdIndexRoute =
  appWorkspaceMemberMemberIdIndexRouteImport.update({
    id: "/member/$memberId/",
    path: "/member/$memberId/",
    getParentRoute: () => appWorkspaceRouteRoute,
  } as any)
const appWorkspaceSettingsAccessIndexRoute =
  appWorkspaceSettingsAccessIndexRouteImport.update({
    id: "/access/",
    path: "/access/",
    getParentRoute: () => appWorkspaceSettingsRouteRoute,
  } as any)
const appWorkspaceSettingsAccessCreateRoute =
  appWorkspaceSettingsAccessCreateRouteImport.update({
    id: "/access/create",
    path: "/access/create",
    getParentRoute: () => appWorkspaceSettingsRouteRoute,
  } as any)
const appWorkspaceSettingsApiIndexRoute =
  appWorkspaceSettingsApiIndexRouteImport.update({
    id: "/api/",
    path: "/api/",
    getParentRoute: () => appWorkspaceSettingsRouteRoute,
  } as any)
const appWorkspaceSettingsIssueTypesIndexRoute =
  appWorkspaceSettingsIssueTypesIndexRouteImport.update({
    id: "/issue-types/",
    path: "/issue-types/",
    getParentRoute: () => appWorkspaceSettingsRouteRoute,
  } as any)
const appWorkspaceSettingsIssueTypesIssueTypeIdRoute =
  appWorkspaceSettingsIssueTypesIssueTypeIdRouteImport.update({
    id: "/issue-types/$issueTypeId",
    path: "/issue-types/$issueTypeId",
    getParentRoute: () => appWorkspaceSettingsRouteRoute,
  } as any)
const appWorkspaceSettingsMembersIndexRoute =
  appWorkspaceSettingsMembersIndexRouteImport.update({
    id: "/members/",
    path: "/members/",
    getParentRoute: () => appWorkspaceSettingsRouteRoute,
  } as any)
const appWorkspaceSettingsMembersUserIdRoute =
  appWorkspaceSettingsMembersUserIdRouteImport.update({
    id: "/members/$userId",
    path: "/members/$userId",
    getParentRoute: () => appWorkspaceSettingsRouteRoute,
  } as any)
const appWorkspaceSettingsTeamsIndexRoute =
  appWorkspaceSettingsTeamsIndexRouteImport.update({
    id: "/teams/",
    path: "/teams/",
    getParentRoute: () => appWorkspaceSettingsRouteRoute,
  } as any)
const appWorkspaceSettingsWorkflowsIndexRoute =
  appWorkspaceSettingsWorkflowsIndexRouteImport.update({
    id: "/workflows/",
    path: "/workflows/",
    getParentRoute: () => appWorkspaceSettingsRouteRoute,
  } as any)
const appWorkspaceTeamTeamIdIndexRoute =
  appWorkspaceTeamTeamIdIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => appWorkspaceTeamTeamIdRouteRoute,
  } as any)
const appWorkspaceTeamTeamIdBoardRoute =
  appWorkspaceTeamTeamIdBoardRouteImport.update({
    id: "/board",
    path: "/board",
    getParentRoute: () => appWorkspaceTeamTeamIdRouteRoute,
  } as any)
const appWorkspaceTeamTeamIdChartRoute =
  appWorkspaceTeamTeamIdChartRouteImport.update({
    id: "/chart",
    path: "/chart",
    getParentRoute: () => appWorkspaceTeamTeamIdRouteRoute,
  } as any)
const appWorkspaceTeamTeamIdListRoute =
  appWorkspaceTeamTeamIdListRouteImport.update({
    id: "/list",
    path: "/list",
    getParentRoute: () => appWorkspaceTeamTeamIdRouteRoute,
  } as any)
const appWorkspaceTeamTeamIdMembersRoute =
  appWorkspaceTeamTeamIdMembersRouteImport.update({
    id: "/members",
    path: "/members",
    getParentRoute: () => appWorkspaceTeamTeamIdRouteRoute,
  } as any)
const appWorkspaceTeamTeamIdOverviewRoute =
  appWorkspaceTeamTeamIdOverviewRouteImport.update({
    id: "/overview",
    path: "/overview",
    getParentRoute: () => appWorkspaceTeamTeamIdRouteRoute,
  } as any)
const appWorkspaceWorkflowWorkflowIdIndexRoute =
  appWorkspaceWorkflowWorkflowIdIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => appWorkspaceWorkflowWorkflowIdRouteRoute,
  } as any)
const appWorkspaceWorkflowWorkflowIdBoardRoute =
  appWorkspaceWorkflowWorkflowIdBoardRouteImport.update({
    id: "/board",
    path: "/board",
    getParentRoute: () => appWorkspaceWorkflowWorkflowIdRouteRoute,
  } as any)
const appWorkspaceWorkflowWorkflowIdDashboardRoute =
  appWorkspaceWorkflowWorkflowIdDashboardRouteImport.update({
    id: "/dashboard",
    path: "/dashboard",
    getParentRoute: () => appWorkspaceWorkflowWorkflowIdRouteRoute,
  } as any)
const appWorkspaceWorkflowWorkflowIdListRoute =
  appWorkspaceWorkflowWorkflowIdListRouteImport.update({
    id: "/list",
    path: "/list",
    getParentRoute: () => appWorkspaceWorkflowWorkflowIdRouteRoute,
  } as any)
const appWorkspaceSettingsAccessApiKeyIdIndexRoute =
  appWorkspaceSettingsAccessApiKeyIdIndexRouteImport.update({
    id: "/access/$apiKeyId/",
    path: "/access/$apiKeyId/",
    getParentRoute: () => appWorkspaceSettingsRouteRoute,
  } as any)
const appWorkspaceSettingsAccessApiKeyIdEditRoute =
  appWorkspaceSettingsAccessApiKeyIdEditRouteImport.update({
    id: "/access/$apiKeyId/edit",
    path: "/access/$apiKeyId/edit",
    getParentRoute: () => appWorkspaceSettingsRouteRoute,
  } as any)
const appWorkspaceSettingsApiKeysCreateRoute =
  appWorkspaceSettingsApiKeysCreateRouteImport.update({
    id: "/api/keys/create",
    path: "/api/keys/create",
    getParentRoute: () => appWorkspaceSettingsRouteRoute,
  } as any)
const appWorkspaceSettingsApiWebhooksCreateRoute =
  appWorkspaceSettingsApiWebhooksCreateRouteImport.update({
    id: "/api/webhooks/create",
    path: "/api/webhooks/create",
    getParentRoute: () => appWorkspaceSettingsRouteRoute,
  } as any)
const appWorkspaceSettingsTeamsTeamIdIndexRoute =
  appWorkspaceSettingsTeamsTeamIdIndexRouteImport.update({
    id: "/teams/$teamId/",
    path: "/teams/$teamId/",
    getParentRoute: () => appWorkspaceSettingsRouteRoute,
  } as any)
const appWorkspaceSettingsWorkflowsWorkflowIdIndexRoute =
  appWorkspaceSettingsWorkflowsWorkflowIdIndexRouteImport.update({
    id: "/workflows/$workflowId/",
    path: "/workflows/$workflowId/",
    getParentRoute: () => appWorkspaceSettingsRouteRoute,
  } as any)
const appWorkspaceWorkflowWorkflowIdViewViewIdRoute =
  appWorkspaceWorkflowWorkflowIdViewViewIdRouteImport.update({
    id: "/view/$viewId",
    path: "/view/$viewId",
    getParentRoute: () => appWorkspaceWorkflowWorkflowIdRouteRoute,
  } as any)
const appWorkspaceSettingsApiKeysApiKeyIdIndexRoute =
  appWorkspaceSettingsApiKeysApiKeyIdIndexRouteImport.update({
    id: "/api/keys/$apiKeyId/",
    path: "/api/keys/$apiKeyId/",
    getParentRoute: () => appWorkspaceSettingsRouteRoute,
  } as any)
const appWorkspaceSettingsApiKeysApiKeyIdEditRoute =
  appWorkspaceSettingsApiKeysApiKeyIdEditRouteImport.update({
    id: "/api/keys/$apiKeyId/edit",
    path: "/api/keys/$apiKeyId/edit",
    getParentRoute: () => appWorkspaceSettingsRouteRoute,
  } as any)
const appWorkspaceSettingsApiWebhooksWebhookIdIndexRoute =
  appWorkspaceSettingsApiWebhooksWebhookIdIndexRouteImport.update({
    id: "/api/webhooks/$webhookId/",
    path: "/api/webhooks/$webhookId/",
    getParentRoute: () => appWorkspaceSettingsRouteRoute,
  } as any)
const appWorkspaceSettingsApiWebhooksWebhookIdEditRoute =
  appWorkspaceSettingsApiWebhooksWebhookIdEditRouteImport.update({
    id: "/api/webhooks/$webhookId/edit",
    path: "/api/webhooks/$webhookId/edit",
    getParentRoute: () => appWorkspaceSettingsRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  "/logout": typeof LogoutRoute
  "/$workspace": typeof appWorkspaceRouteRouteWithChildren
  "/admin": typeof appAdminRoute
  "/workspace-create": typeof appWorkspaceCreateRoute
  "/workspace-select": typeof appWorkspaceSelectRoute
  "/accept-invite": typeof authAcceptInviteRoute
  "/forgot-password": typeof authForgotPasswordRoute
  "/login": typeof authLoginRoute
  "/register": typeof authRegisterRoute
  "/reset-password": typeof authResetPasswordRoute
  "/reset-password-sent": typeof authResetPasswordSentRoute
  "/verify-email": typeof authVerifyEmailRoute
  "/verify-email-sent": typeof authVerifyEmailSentRoute
  "/": typeof appIndexRoute
  "/$workspace/settings": typeof appWorkspaceSettingsRouteRouteWithChildren
  "/$workspace/$": typeof appWorkspaceSplatRoute
  "/$workspace/inbox": typeof appWorkspaceInboxRoute
  "/$workspace/map": typeof appWorkspaceMapRoute
  "/$workspace/members": typeof appWorkspaceMembersRoute
  "/$workspace/my-work": typeof appWorkspaceMyWorkRoute
  "/$workspace/org-chart": typeof appWorkspaceOrgChartRoute
  "/$workspace/shared": typeof appWorkspaceSharedRoute
  "/$workspace/teams": typeof appWorkspaceTeamsRoute
  "/$workspace/workflows": typeof appWorkspaceWorkflowsRoute
  "/$workspace/": typeof appWorkspaceIndexRoute
  "/$workspace/team/$teamId": typeof appWorkspaceTeamTeamIdRouteRouteWithChildren
  "/$workspace/workflow/$workflowId": typeof appWorkspaceWorkflowWorkflowIdRouteRouteWithChildren
  "/$workspace/dashboards/$viewId": typeof appWorkspaceDashboardsViewIdRoute
  "/$workspace/dashboards/my": typeof appWorkspaceDashboardsMyRoute
  "/$workspace/settings/appearance": typeof appWorkspaceSettingsAppearanceRoute
  "/$workspace/settings/custom-fields": typeof appWorkspaceSettingsCustomFieldsRoute
  "/$workspace/settings/issue-sources": typeof appWorkspaceSettingsIssueSourcesRoute
  "/$workspace/settings/outcomes": typeof appWorkspaceSettingsOutcomesRoute
  "/$workspace/settings/permissions": typeof appWorkspaceSettingsPermissionsRoute
  "/$workspace/settings/preferences": typeof appWorkspaceSettingsPreferencesRoute
  "/$workspace/settings/profile": typeof appWorkspaceSettingsProfileRoute
  "/$workspace/settings/trash": typeof appWorkspaceSettingsTrashRoute
  "/$workspace/settings/updates": typeof appWorkspaceSettingsUpdatesRoute
  "/$workspace/settings/workspace": typeof appWorkspaceSettingsWorkspaceRoute
  "/$workspace/dashboards/": typeof appWorkspaceDashboardsIndexRoute
  "/$workspace/settings/": typeof appWorkspaceSettingsIndexRoute
  "/$workspace/settings/access/create": typeof appWorkspaceSettingsAccessCreateRoute
  "/$workspace/settings/issue-types/$issueTypeId": typeof appWorkspaceSettingsIssueTypesIssueTypeIdRoute
  "/$workspace/settings/members/$userId": typeof appWorkspaceSettingsMembersUserIdRoute
  "/$workspace/team/$teamId/board": typeof appWorkspaceTeamTeamIdBoardRoute
  "/$workspace/team/$teamId/chart": typeof appWorkspaceTeamTeamIdChartRoute
  "/$workspace/team/$teamId/list": typeof appWorkspaceTeamTeamIdListRoute
  "/$workspace/team/$teamId/members": typeof appWorkspaceTeamTeamIdMembersRoute
  "/$workspace/team/$teamId/overview": typeof appWorkspaceTeamTeamIdOverviewRoute
  "/$workspace/workflow/$workflowId/board": typeof appWorkspaceWorkflowWorkflowIdBoardRoute
  "/$workspace/workflow/$workflowId/dashboard": typeof appWorkspaceWorkflowWorkflowIdDashboardRoute
  "/$workspace/workflow/$workflowId/list": typeof appWorkspaceWorkflowWorkflowIdListRoute
  "/$workspace/member/$memberId/": typeof appWorkspaceMemberMemberIdIndexRoute
  "/$workspace/settings/access/": typeof appWorkspaceSettingsAccessIndexRoute
  "/$workspace/settings/api/": typeof appWorkspaceSettingsApiIndexRoute
  "/$workspace/settings/issue-types/": typeof appWorkspaceSettingsIssueTypesIndexRoute
  "/$workspace/settings/members/": typeof appWorkspaceSettingsMembersIndexRoute
  "/$workspace/settings/teams/": typeof appWorkspaceSettingsTeamsIndexRoute
  "/$workspace/settings/workflows/": typeof appWorkspaceSettingsWorkflowsIndexRoute
  "/$workspace/team/$teamId/": typeof appWorkspaceTeamTeamIdIndexRoute
  "/$workspace/workflow/$workflowId/": typeof appWorkspaceWorkflowWorkflowIdIndexRoute
  "/$workspace/settings/access/$apiKeyId/edit": typeof appWorkspaceSettingsAccessApiKeyIdEditRoute
  "/$workspace/settings/api/keys/create": typeof appWorkspaceSettingsApiKeysCreateRoute
  "/$workspace/settings/api/webhooks/create": typeof appWorkspaceSettingsApiWebhooksCreateRoute
  "/$workspace/workflow/$workflowId/view/$viewId": typeof appWorkspaceWorkflowWorkflowIdViewViewIdRoute
  "/$workspace/settings/access/$apiKeyId/": typeof appWorkspaceSettingsAccessApiKeyIdIndexRoute
  "/$workspace/settings/teams/$teamId/": typeof appWorkspaceSettingsTeamsTeamIdIndexRoute
  "/$workspace/settings/workflows/$workflowId/": typeof appWorkspaceSettingsWorkflowsWorkflowIdIndexRoute
  "/$workspace/settings/api/keys/$apiKeyId/edit": typeof appWorkspaceSettingsApiKeysApiKeyIdEditRoute
  "/$workspace/settings/api/webhooks/$webhookId/edit": typeof appWorkspaceSettingsApiWebhooksWebhookIdEditRoute
  "/$workspace/settings/api/keys/$apiKeyId/": typeof appWorkspaceSettingsApiKeysApiKeyIdIndexRoute
  "/$workspace/settings/api/webhooks/$webhookId/": typeof appWorkspaceSettingsApiWebhooksWebhookIdIndexRoute
}
export interface FileRoutesByTo {
  "/logout": typeof LogoutRoute
  "/admin": typeof appAdminRoute
  "/workspace-create": typeof appWorkspaceCreateRoute
  "/workspace-select": typeof appWorkspaceSelectRoute
  "/accept-invite": typeof authAcceptInviteRoute
  "/forgot-password": typeof authForgotPasswordRoute
  "/login": typeof authLoginRoute
  "/register": typeof authRegisterRoute
  "/reset-password": typeof authResetPasswordRoute
  "/reset-password-sent": typeof authResetPasswordSentRoute
  "/verify-email": typeof authVerifyEmailRoute
  "/verify-email-sent": typeof authVerifyEmailSentRoute
  "/": typeof appIndexRoute
  "/$workspace/$": typeof appWorkspaceSplatRoute
  "/$workspace/inbox": typeof appWorkspaceInboxRoute
  "/$workspace/map": typeof appWorkspaceMapRoute
  "/$workspace/members": typeof appWorkspaceMembersRoute
  "/$workspace/my-work": typeof appWorkspaceMyWorkRoute
  "/$workspace/org-chart": typeof appWorkspaceOrgChartRoute
  "/$workspace/shared": typeof appWorkspaceSharedRoute
  "/$workspace/teams": typeof appWorkspaceTeamsRoute
  "/$workspace/workflows": typeof appWorkspaceWorkflowsRoute
  "/$workspace": typeof appWorkspaceIndexRoute
  "/$workspace/dashboards/$viewId": typeof appWorkspaceDashboardsViewIdRoute
  "/$workspace/dashboards/my": typeof appWorkspaceDashboardsMyRoute
  "/$workspace/settings/appearance": typeof appWorkspaceSettingsAppearanceRoute
  "/$workspace/settings/custom-fields": typeof appWorkspaceSettingsCustomFieldsRoute
  "/$workspace/settings/issue-sources": typeof appWorkspaceSettingsIssueSourcesRoute
  "/$workspace/settings/outcomes": typeof appWorkspaceSettingsOutcomesRoute
  "/$workspace/settings/permissions": typeof appWorkspaceSettingsPermissionsRoute
  "/$workspace/settings/preferences": typeof appWorkspaceSettingsPreferencesRoute
  "/$workspace/settings/profile": typeof appWorkspaceSettingsProfileRoute
  "/$workspace/settings/trash": typeof appWorkspaceSettingsTrashRoute
  "/$workspace/settings/updates": typeof appWorkspaceSettingsUpdatesRoute
  "/$workspace/settings/workspace": typeof appWorkspaceSettingsWorkspaceRoute
  "/$workspace/dashboards": typeof appWorkspaceDashboardsIndexRoute
  "/$workspace/settings": typeof appWorkspaceSettingsIndexRoute
  "/$workspace/settings/access/create": typeof appWorkspaceSettingsAccessCreateRoute
  "/$workspace/settings/issue-types/$issueTypeId": typeof appWorkspaceSettingsIssueTypesIssueTypeIdRoute
  "/$workspace/settings/members/$userId": typeof appWorkspaceSettingsMembersUserIdRoute
  "/$workspace/team/$teamId/board": typeof appWorkspaceTeamTeamIdBoardRoute
  "/$workspace/team/$teamId/chart": typeof appWorkspaceTeamTeamIdChartRoute
  "/$workspace/team/$teamId/list": typeof appWorkspaceTeamTeamIdListRoute
  "/$workspace/team/$teamId/members": typeof appWorkspaceTeamTeamIdMembersRoute
  "/$workspace/team/$teamId/overview": typeof appWorkspaceTeamTeamIdOverviewRoute
  "/$workspace/workflow/$workflowId/board": typeof appWorkspaceWorkflowWorkflowIdBoardRoute
  "/$workspace/workflow/$workflowId/dashboard": typeof appWorkspaceWorkflowWorkflowIdDashboardRoute
  "/$workspace/workflow/$workflowId/list": typeof appWorkspaceWorkflowWorkflowIdListRoute
  "/$workspace/member/$memberId": typeof appWorkspaceMemberMemberIdIndexRoute
  "/$workspace/settings/access": typeof appWorkspaceSettingsAccessIndexRoute
  "/$workspace/settings/api": typeof appWorkspaceSettingsApiIndexRoute
  "/$workspace/settings/issue-types": typeof appWorkspaceSettingsIssueTypesIndexRoute
  "/$workspace/settings/members": typeof appWorkspaceSettingsMembersIndexRoute
  "/$workspace/settings/teams": typeof appWorkspaceSettingsTeamsIndexRoute
  "/$workspace/settings/workflows": typeof appWorkspaceSettingsWorkflowsIndexRoute
  "/$workspace/team/$teamId": typeof appWorkspaceTeamTeamIdIndexRoute
  "/$workspace/workflow/$workflowId": typeof appWorkspaceWorkflowWorkflowIdIndexRoute
  "/$workspace/settings/access/$apiKeyId/edit": typeof appWorkspaceSettingsAccessApiKeyIdEditRoute
  "/$workspace/settings/api/keys/create": typeof appWorkspaceSettingsApiKeysCreateRoute
  "/$workspace/settings/api/webhooks/create": typeof appWorkspaceSettingsApiWebhooksCreateRoute
  "/$workspace/workflow/$workflowId/view/$viewId": typeof appWorkspaceWorkflowWorkflowIdViewViewIdRoute
  "/$workspace/settings/access/$apiKeyId": typeof appWorkspaceSettingsAccessApiKeyIdIndexRoute
  "/$workspace/settings/teams/$teamId": typeof appWorkspaceSettingsTeamsTeamIdIndexRoute
  "/$workspace/settings/workflows/$workflowId": typeof appWorkspaceSettingsWorkflowsWorkflowIdIndexRoute
  "/$workspace/settings/api/keys/$apiKeyId/edit": typeof appWorkspaceSettingsApiKeysApiKeyIdEditRoute
  "/$workspace/settings/api/webhooks/$webhookId/edit": typeof appWorkspaceSettingsApiWebhooksWebhookIdEditRoute
  "/$workspace/settings/api/keys/$apiKeyId": typeof appWorkspaceSettingsApiKeysApiKeyIdIndexRoute
  "/$workspace/settings/api/webhooks/$webhookId": typeof appWorkspaceSettingsApiWebhooksWebhookIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/(app)": typeof appRouteRouteWithChildren
  "/(auth)": typeof authRouteRouteWithChildren
  "/logout": typeof LogoutRoute
  "/(app)/$workspace": typeof appWorkspaceRouteRouteWithChildren
  "/(app)/admin": typeof appAdminRoute
  "/(app)/workspace-create": typeof appWorkspaceCreateRoute
  "/(app)/workspace-select": typeof appWorkspaceSelectRoute
  "/(auth)/accept-invite": typeof authAcceptInviteRoute
  "/(auth)/forgot-password": typeof authForgotPasswordRoute
  "/(auth)/login": typeof authLoginRoute
  "/(auth)/register": typeof authRegisterRoute
  "/(auth)/reset-password": typeof authResetPasswordRoute
  "/(auth)/reset-password-sent": typeof authResetPasswordSentRoute
  "/(auth)/verify-email": typeof authVerifyEmailRoute
  "/(auth)/verify-email-sent": typeof authVerifyEmailSentRoute
  "/(app)/": typeof appIndexRoute
  "/(app)/$workspace/settings": typeof appWorkspaceSettingsRouteRouteWithChildren
  "/(app)/$workspace/$": typeof appWorkspaceSplatRoute
  "/(app)/$workspace/inbox": typeof appWorkspaceInboxRoute
  "/(app)/$workspace/map": typeof appWorkspaceMapRoute
  "/(app)/$workspace/members": typeof appWorkspaceMembersRoute
  "/(app)/$workspace/my-work": typeof appWorkspaceMyWorkRoute
  "/(app)/$workspace/org-chart": typeof appWorkspaceOrgChartRoute
  "/(app)/$workspace/shared": typeof appWorkspaceSharedRoute
  "/(app)/$workspace/teams": typeof appWorkspaceTeamsRoute
  "/(app)/$workspace/workflows": typeof appWorkspaceWorkflowsRoute
  "/(app)/$workspace/": typeof appWorkspaceIndexRoute
  "/(app)/$workspace/team/$teamId": typeof appWorkspaceTeamTeamIdRouteRouteWithChildren
  "/(app)/$workspace/workflow/$workflowId": typeof appWorkspaceWorkflowWorkflowIdRouteRouteWithChildren
  "/(app)/$workspace/dashboards/$viewId": typeof appWorkspaceDashboardsViewIdRoute
  "/(app)/$workspace/dashboards/my": typeof appWorkspaceDashboardsMyRoute
  "/(app)/$workspace/settings/appearance": typeof appWorkspaceSettingsAppearanceRoute
  "/(app)/$workspace/settings/custom-fields": typeof appWorkspaceSettingsCustomFieldsRoute
  "/(app)/$workspace/settings/issue-sources": typeof appWorkspaceSettingsIssueSourcesRoute
  "/(app)/$workspace/settings/outcomes": typeof appWorkspaceSettingsOutcomesRoute
  "/(app)/$workspace/settings/permissions": typeof appWorkspaceSettingsPermissionsRoute
  "/(app)/$workspace/settings/preferences": typeof appWorkspaceSettingsPreferencesRoute
  "/(app)/$workspace/settings/profile": typeof appWorkspaceSettingsProfileRoute
  "/(app)/$workspace/settings/trash": typeof appWorkspaceSettingsTrashRoute
  "/(app)/$workspace/settings/updates": typeof appWorkspaceSettingsUpdatesRoute
  "/(app)/$workspace/settings/workspace": typeof appWorkspaceSettingsWorkspaceRoute
  "/(app)/$workspace/dashboards/": typeof appWorkspaceDashboardsIndexRoute
  "/(app)/$workspace/settings/": typeof appWorkspaceSettingsIndexRoute
  "/(app)/$workspace/settings/access/create": typeof appWorkspaceSettingsAccessCreateRoute
  "/(app)/$workspace/settings/issue-types/$issueTypeId": typeof appWorkspaceSettingsIssueTypesIssueTypeIdRoute
  "/(app)/$workspace/settings/members/$userId": typeof appWorkspaceSettingsMembersUserIdRoute
  "/(app)/$workspace/team/$teamId/board": typeof appWorkspaceTeamTeamIdBoardRoute
  "/(app)/$workspace/team/$teamId/chart": typeof appWorkspaceTeamTeamIdChartRoute
  "/(app)/$workspace/team/$teamId/list": typeof appWorkspaceTeamTeamIdListRoute
  "/(app)/$workspace/team/$teamId/members": typeof appWorkspaceTeamTeamIdMembersRoute
  "/(app)/$workspace/team/$teamId/overview": typeof appWorkspaceTeamTeamIdOverviewRoute
  "/(app)/$workspace/workflow/$workflowId/board": typeof appWorkspaceWorkflowWorkflowIdBoardRoute
  "/(app)/$workspace/workflow/$workflowId/dashboard": typeof appWorkspaceWorkflowWorkflowIdDashboardRoute
  "/(app)/$workspace/workflow/$workflowId/list": typeof appWorkspaceWorkflowWorkflowIdListRoute
  "/(app)/$workspace/member/$memberId/": typeof appWorkspaceMemberMemberIdIndexRoute
  "/(app)/$workspace/settings/access/": typeof appWorkspaceSettingsAccessIndexRoute
  "/(app)/$workspace/settings/api/": typeof appWorkspaceSettingsApiIndexRoute
  "/(app)/$workspace/settings/issue-types/": typeof appWorkspaceSettingsIssueTypesIndexRoute
  "/(app)/$workspace/settings/members/": typeof appWorkspaceSettingsMembersIndexRoute
  "/(app)/$workspace/settings/teams/": typeof appWorkspaceSettingsTeamsIndexRoute
  "/(app)/$workspace/settings/workflows/": typeof appWorkspaceSettingsWorkflowsIndexRoute
  "/(app)/$workspace/team/$teamId/": typeof appWorkspaceTeamTeamIdIndexRoute
  "/(app)/$workspace/workflow/$workflowId/": typeof appWorkspaceWorkflowWorkflowIdIndexRoute
  "/(app)/$workspace/settings/access/$apiKeyId/edit": typeof appWorkspaceSettingsAccessApiKeyIdEditRoute
  "/(app)/$workspace/settings/api/keys/create": typeof appWorkspaceSettingsApiKeysCreateRoute
  "/(app)/$workspace/settings/api/webhooks/create": typeof appWorkspaceSettingsApiWebhooksCreateRoute
  "/(app)/$workspace/workflow/$workflowId/view/$viewId": typeof appWorkspaceWorkflowWorkflowIdViewViewIdRoute
  "/(app)/$workspace/settings/access/$apiKeyId/": typeof appWorkspaceSettingsAccessApiKeyIdIndexRoute
  "/(app)/$workspace/settings/teams/$teamId/": typeof appWorkspaceSettingsTeamsTeamIdIndexRoute
  "/(app)/$workspace/settings/workflows/$workflowId/": typeof appWorkspaceSettingsWorkflowsWorkflowIdIndexRoute
  "/(app)/$workspace/settings/api/keys/$apiKeyId/edit": typeof appWorkspaceSettingsApiKeysApiKeyIdEditRoute
  "/(app)/$workspace/settings/api/webhooks/$webhookId/edit": typeof appWorkspaceSettingsApiWebhooksWebhookIdEditRoute
  "/(app)/$workspace/settings/api/keys/$apiKeyId/": typeof appWorkspaceSettingsApiKeysApiKeyIdIndexRoute
  "/(app)/$workspace/settings/api/webhooks/$webhookId/": typeof appWorkspaceSettingsApiWebhooksWebhookIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/logout"
    | "/$workspace"
    | "/admin"
    | "/workspace-create"
    | "/workspace-select"
    | "/accept-invite"
    | "/forgot-password"
    | "/login"
    | "/register"
    | "/reset-password"
    | "/reset-password-sent"
    | "/verify-email"
    | "/verify-email-sent"
    | "/"
    | "/$workspace/settings"
    | "/$workspace/$"
    | "/$workspace/inbox"
    | "/$workspace/map"
    | "/$workspace/members"
    | "/$workspace/my-work"
    | "/$workspace/org-chart"
    | "/$workspace/shared"
    | "/$workspace/teams"
    | "/$workspace/workflows"
    | "/$workspace/"
    | "/$workspace/team/$teamId"
    | "/$workspace/workflow/$workflowId"
    | "/$workspace/dashboards/$viewId"
    | "/$workspace/dashboards/my"
    | "/$workspace/settings/appearance"
    | "/$workspace/settings/custom-fields"
    | "/$workspace/settings/issue-sources"
    | "/$workspace/settings/outcomes"
    | "/$workspace/settings/permissions"
    | "/$workspace/settings/preferences"
    | "/$workspace/settings/profile"
    | "/$workspace/settings/trash"
    | "/$workspace/settings/updates"
    | "/$workspace/settings/workspace"
    | "/$workspace/dashboards/"
    | "/$workspace/settings/"
    | "/$workspace/settings/access/create"
    | "/$workspace/settings/issue-types/$issueTypeId"
    | "/$workspace/settings/members/$userId"
    | "/$workspace/team/$teamId/board"
    | "/$workspace/team/$teamId/chart"
    | "/$workspace/team/$teamId/list"
    | "/$workspace/team/$teamId/members"
    | "/$workspace/team/$teamId/overview"
    | "/$workspace/workflow/$workflowId/board"
    | "/$workspace/workflow/$workflowId/dashboard"
    | "/$workspace/workflow/$workflowId/list"
    | "/$workspace/member/$memberId/"
    | "/$workspace/settings/access/"
    | "/$workspace/settings/api/"
    | "/$workspace/settings/issue-types/"
    | "/$workspace/settings/members/"
    | "/$workspace/settings/teams/"
    | "/$workspace/settings/workflows/"
    | "/$workspace/team/$teamId/"
    | "/$workspace/workflow/$workflowId/"
    | "/$workspace/settings/access/$apiKeyId/edit"
    | "/$workspace/settings/api/keys/create"
    | "/$workspace/settings/api/webhooks/create"
    | "/$workspace/workflow/$workflowId/view/$viewId"
    | "/$workspace/settings/access/$apiKeyId/"
    | "/$workspace/settings/teams/$teamId/"
    | "/$workspace/settings/workflows/$workflowId/"
    | "/$workspace/settings/api/keys/$apiKeyId/edit"
    | "/$workspace/settings/api/webhooks/$webhookId/edit"
    | "/$workspace/settings/api/keys/$apiKeyId/"
    | "/$workspace/settings/api/webhooks/$webhookId/"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/logout"
    | "/admin"
    | "/workspace-create"
    | "/workspace-select"
    | "/accept-invite"
    | "/forgot-password"
    | "/login"
    | "/register"
    | "/reset-password"
    | "/reset-password-sent"
    | "/verify-email"
    | "/verify-email-sent"
    | "/"
    | "/$workspace/$"
    | "/$workspace/inbox"
    | "/$workspace/map"
    | "/$workspace/members"
    | "/$workspace/my-work"
    | "/$workspace/org-chart"
    | "/$workspace/shared"
    | "/$workspace/teams"
    | "/$workspace/workflows"
    | "/$workspace"
    | "/$workspace/dashboards/$viewId"
    | "/$workspace/dashboards/my"
    | "/$workspace/settings/appearance"
    | "/$workspace/settings/custom-fields"
    | "/$workspace/settings/issue-sources"
    | "/$workspace/settings/outcomes"
    | "/$workspace/settings/permissions"
    | "/$workspace/settings/preferences"
    | "/$workspace/settings/profile"
    | "/$workspace/settings/trash"
    | "/$workspace/settings/updates"
    | "/$workspace/settings/workspace"
    | "/$workspace/dashboards"
    | "/$workspace/settings"
    | "/$workspace/settings/access/create"
    | "/$workspace/settings/issue-types/$issueTypeId"
    | "/$workspace/settings/members/$userId"
    | "/$workspace/team/$teamId/board"
    | "/$workspace/team/$teamId/chart"
    | "/$workspace/team/$teamId/list"
    | "/$workspace/team/$teamId/members"
    | "/$workspace/team/$teamId/overview"
    | "/$workspace/workflow/$workflowId/board"
    | "/$workspace/workflow/$workflowId/dashboard"
    | "/$workspace/workflow/$workflowId/list"
    | "/$workspace/member/$memberId"
    | "/$workspace/settings/access"
    | "/$workspace/settings/api"
    | "/$workspace/settings/issue-types"
    | "/$workspace/settings/members"
    | "/$workspace/settings/teams"
    | "/$workspace/settings/workflows"
    | "/$workspace/team/$teamId"
    | "/$workspace/workflow/$workflowId"
    | "/$workspace/settings/access/$apiKeyId/edit"
    | "/$workspace/settings/api/keys/create"
    | "/$workspace/settings/api/webhooks/create"
    | "/$workspace/workflow/$workflowId/view/$viewId"
    | "/$workspace/settings/access/$apiKeyId"
    | "/$workspace/settings/teams/$teamId"
    | "/$workspace/settings/workflows/$workflowId"
    | "/$workspace/settings/api/keys/$apiKeyId/edit"
    | "/$workspace/settings/api/webhooks/$webhookId/edit"
    | "/$workspace/settings/api/keys/$apiKeyId"
    | "/$workspace/settings/api/webhooks/$webhookId"
  id:
    | "__root__"
    | "/(app)"
    | "/(auth)"
    | "/logout"
    | "/(app)/$workspace"
    | "/(app)/admin"
    | "/(app)/workspace-create"
    | "/(app)/workspace-select"
    | "/(auth)/accept-invite"
    | "/(auth)/forgot-password"
    | "/(auth)/login"
    | "/(auth)/register"
    | "/(auth)/reset-password"
    | "/(auth)/reset-password-sent"
    | "/(auth)/verify-email"
    | "/(auth)/verify-email-sent"
    | "/(app)/"
    | "/(app)/$workspace/settings"
    | "/(app)/$workspace/$"
    | "/(app)/$workspace/inbox"
    | "/(app)/$workspace/map"
    | "/(app)/$workspace/members"
    | "/(app)/$workspace/my-work"
    | "/(app)/$workspace/org-chart"
    | "/(app)/$workspace/shared"
    | "/(app)/$workspace/teams"
    | "/(app)/$workspace/workflows"
    | "/(app)/$workspace/"
    | "/(app)/$workspace/team/$teamId"
    | "/(app)/$workspace/workflow/$workflowId"
    | "/(app)/$workspace/dashboards/$viewId"
    | "/(app)/$workspace/dashboards/my"
    | "/(app)/$workspace/settings/appearance"
    | "/(app)/$workspace/settings/custom-fields"
    | "/(app)/$workspace/settings/issue-sources"
    | "/(app)/$workspace/settings/outcomes"
    | "/(app)/$workspace/settings/permissions"
    | "/(app)/$workspace/settings/preferences"
    | "/(app)/$workspace/settings/profile"
    | "/(app)/$workspace/settings/trash"
    | "/(app)/$workspace/settings/updates"
    | "/(app)/$workspace/settings/workspace"
    | "/(app)/$workspace/dashboards/"
    | "/(app)/$workspace/settings/"
    | "/(app)/$workspace/settings/access/create"
    | "/(app)/$workspace/settings/issue-types/$issueTypeId"
    | "/(app)/$workspace/settings/members/$userId"
    | "/(app)/$workspace/team/$teamId/board"
    | "/(app)/$workspace/team/$teamId/chart"
    | "/(app)/$workspace/team/$teamId/list"
    | "/(app)/$workspace/team/$teamId/members"
    | "/(app)/$workspace/team/$teamId/overview"
    | "/(app)/$workspace/workflow/$workflowId/board"
    | "/(app)/$workspace/workflow/$workflowId/dashboard"
    | "/(app)/$workspace/workflow/$workflowId/list"
    | "/(app)/$workspace/member/$memberId/"
    | "/(app)/$workspace/settings/access/"
    | "/(app)/$workspace/settings/api/"
    | "/(app)/$workspace/settings/issue-types/"
    | "/(app)/$workspace/settings/members/"
    | "/(app)/$workspace/settings/teams/"
    | "/(app)/$workspace/settings/workflows/"
    | "/(app)/$workspace/team/$teamId/"
    | "/(app)/$workspace/workflow/$workflowId/"
    | "/(app)/$workspace/settings/access/$apiKeyId/edit"
    | "/(app)/$workspace/settings/api/keys/create"
    | "/(app)/$workspace/settings/api/webhooks/create"
    | "/(app)/$workspace/workflow/$workflowId/view/$viewId"
    | "/(app)/$workspace/settings/access/$apiKeyId/"
    | "/(app)/$workspace/settings/teams/$teamId/"
    | "/(app)/$workspace/settings/workflows/$workflowId/"
    | "/(app)/$workspace/settings/api/keys/$apiKeyId/edit"
    | "/(app)/$workspace/settings/api/webhooks/$webhookId/edit"
    | "/(app)/$workspace/settings/api/keys/$apiKeyId/"
    | "/(app)/$workspace/settings/api/webhooks/$webhookId/"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  appRouteRoute: typeof appRouteRouteWithChildren
  authRouteRoute: typeof authRouteRouteWithChildren
  LogoutRoute: typeof LogoutRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/(app)": {
      id: "/(app)"
      path: ""
      fullPath: ""
      preLoaderRoute: typeof appRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/(auth)": {
      id: "/(auth)"
      path: ""
      fullPath: ""
      preLoaderRoute: typeof authRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/logout": {
      id: "/logout"
      path: "/logout"
      fullPath: "/logout"
      preLoaderRoute: typeof LogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/(app)/": {
      id: "/(app)/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof appIndexRouteImport
      parentRoute: typeof appRouteRoute
    }
    "/(app)/$workspace": {
      id: "/(app)/$workspace"
      path: "/$workspace"
      fullPath: "/$workspace"
      preLoaderRoute: typeof appWorkspaceRouteRouteImport
      parentRoute: typeof appRouteRoute
    }
    "/(app)/admin": {
      id: "/(app)/admin"
      path: "/admin"
      fullPath: "/admin"
      preLoaderRoute: typeof appAdminRouteImport
      parentRoute: typeof appRouteRoute
    }
    "/(app)/workspace-create": {
      id: "/(app)/workspace-create"
      path: "/workspace-create"
      fullPath: "/workspace-create"
      preLoaderRoute: typeof appWorkspaceCreateRouteImport
      parentRoute: typeof appRouteRoute
    }
    "/(app)/workspace-select": {
      id: "/(app)/workspace-select"
      path: "/workspace-select"
      fullPath: "/workspace-select"
      preLoaderRoute: typeof appWorkspaceSelectRouteImport
      parentRoute: typeof appRouteRoute
    }
    "/(auth)/accept-invite": {
      id: "/(auth)/accept-invite"
      path: "/accept-invite"
      fullPath: "/accept-invite"
      preLoaderRoute: typeof authAcceptInviteRouteImport
      parentRoute: typeof authRouteRoute
    }
    "/(auth)/forgot-password": {
      id: "/(auth)/forgot-password"
      path: "/forgot-password"
      fullPath: "/forgot-password"
      preLoaderRoute: typeof authForgotPasswordRouteImport
      parentRoute: typeof authRouteRoute
    }
    "/(auth)/login": {
      id: "/(auth)/login"
      path: "/login"
      fullPath: "/login"
      preLoaderRoute: typeof authLoginRouteImport
      parentRoute: typeof authRouteRoute
    }
    "/(auth)/register": {
      id: "/(auth)/register"
      path: "/register"
      fullPath: "/register"
      preLoaderRoute: typeof authRegisterRouteImport
      parentRoute: typeof authRouteRoute
    }
    "/(auth)/reset-password": {
      id: "/(auth)/reset-password"
      path: "/reset-password"
      fullPath: "/reset-password"
      preLoaderRoute: typeof authResetPasswordRouteImport
      parentRoute: typeof authRouteRoute
    }
    "/(auth)/reset-password-sent": {
      id: "/(auth)/reset-password-sent"
      path: "/reset-password-sent"
      fullPath: "/reset-password-sent"
      preLoaderRoute: typeof authResetPasswordSentRouteImport
      parentRoute: typeof authRouteRoute
    }
    "/(auth)/verify-email": {
      id: "/(auth)/verify-email"
      path: "/verify-email"
      fullPath: "/verify-email"
      preLoaderRoute: typeof authVerifyEmailRouteImport
      parentRoute: typeof authRouteRoute
    }
    "/(auth)/verify-email-sent": {
      id: "/(auth)/verify-email-sent"
      path: "/verify-email-sent"
      fullPath: "/verify-email-sent"
      preLoaderRoute: typeof authVerifyEmailSentRouteImport
      parentRoute: typeof authRouteRoute
    }
    "/(app)/$workspace/": {
      id: "/(app)/$workspace/"
      path: "/"
      fullPath: "/$workspace/"
      preLoaderRoute: typeof appWorkspaceIndexRouteImport
      parentRoute: typeof appWorkspaceRouteRoute
    }
    "/(app)/$workspace/$": {
      id: "/(app)/$workspace/$"
      path: "/$"
      fullPath: "/$workspace/$"
      preLoaderRoute: typeof appWorkspaceSplatRouteImport
      parentRoute: typeof appWorkspaceRouteRoute
    }
    "/(app)/$workspace/inbox": {
      id: "/(app)/$workspace/inbox"
      path: "/inbox"
      fullPath: "/$workspace/inbox"
      preLoaderRoute: typeof appWorkspaceInboxRouteImport
      parentRoute: typeof appWorkspaceRouteRoute
    }
    "/(app)/$workspace/map": {
      id: "/(app)/$workspace/map"
      path: "/map"
      fullPath: "/$workspace/map"
      preLoaderRoute: typeof appWorkspaceMapRouteImport
      parentRoute: typeof appWorkspaceRouteRoute
    }
    "/(app)/$workspace/members": {
      id: "/(app)/$workspace/members"
      path: "/members"
      fullPath: "/$workspace/members"
      preLoaderRoute: typeof appWorkspaceMembersRouteImport
      parentRoute: typeof appWorkspaceRouteRoute
    }
    "/(app)/$workspace/my-work": {
      id: "/(app)/$workspace/my-work"
      path: "/my-work"
      fullPath: "/$workspace/my-work"
      preLoaderRoute: typeof appWorkspaceMyWorkRouteImport
      parentRoute: typeof appWorkspaceRouteRoute
    }
    "/(app)/$workspace/org-chart": {
      id: "/(app)/$workspace/org-chart"
      path: "/org-chart"
      fullPath: "/$workspace/org-chart"
      preLoaderRoute: typeof appWorkspaceOrgChartRouteImport
      parentRoute: typeof appWorkspaceRouteRoute
    }
    "/(app)/$workspace/settings": {
      id: "/(app)/$workspace/settings"
      path: "/settings"
      fullPath: "/$workspace/settings"
      preLoaderRoute: typeof appWorkspaceSettingsRouteRouteImport
      parentRoute: typeof appWorkspaceRouteRoute
    }
    "/(app)/$workspace/shared": {
      id: "/(app)/$workspace/shared"
      path: "/shared"
      fullPath: "/$workspace/shared"
      preLoaderRoute: typeof appWorkspaceSharedRouteImport
      parentRoute: typeof appWorkspaceRouteRoute
    }
    "/(app)/$workspace/teams": {
      id: "/(app)/$workspace/teams"
      path: "/teams"
      fullPath: "/$workspace/teams"
      preLoaderRoute: typeof appWorkspaceTeamsRouteImport
      parentRoute: typeof appWorkspaceRouteRoute
    }
    "/(app)/$workspace/workflows": {
      id: "/(app)/$workspace/workflows"
      path: "/workflows"
      fullPath: "/$workspace/workflows"
      preLoaderRoute: typeof appWorkspaceWorkflowsRouteImport
      parentRoute: typeof appWorkspaceRouteRoute
    }
    "/(app)/$workspace/dashboards/": {
      id: "/(app)/$workspace/dashboards/"
      path: "/dashboards"
      fullPath: "/$workspace/dashboards/"
      preLoaderRoute: typeof appWorkspaceDashboardsIndexRouteImport
      parentRoute: typeof appWorkspaceRouteRoute
    }
    "/(app)/$workspace/dashboards/$viewId": {
      id: "/(app)/$workspace/dashboards/$viewId"
      path: "/dashboards/$viewId"
      fullPath: "/$workspace/dashboards/$viewId"
      preLoaderRoute: typeof appWorkspaceDashboardsViewIdRouteImport
      parentRoute: typeof appWorkspaceRouteRoute
    }
    "/(app)/$workspace/dashboards/my": {
      id: "/(app)/$workspace/dashboards/my"
      path: "/dashboards/my"
      fullPath: "/$workspace/dashboards/my"
      preLoaderRoute: typeof appWorkspaceDashboardsMyRouteImport
      parentRoute: typeof appWorkspaceRouteRoute
    }
    "/(app)/$workspace/settings/": {
      id: "/(app)/$workspace/settings/"
      path: "/"
      fullPath: "/$workspace/settings/"
      preLoaderRoute: typeof appWorkspaceSettingsIndexRouteImport
      parentRoute: typeof appWorkspaceSettingsRouteRoute
    }
    "/(app)/$workspace/settings/appearance": {
      id: "/(app)/$workspace/settings/appearance"
      path: "/appearance"
      fullPath: "/$workspace/settings/appearance"
      preLoaderRoute: typeof appWorkspaceSettingsAppearanceRouteImport
      parentRoute: typeof appWorkspaceSettingsRouteRoute
    }
    "/(app)/$workspace/settings/custom-fields": {
      id: "/(app)/$workspace/settings/custom-fields"
      path: "/custom-fields"
      fullPath: "/$workspace/settings/custom-fields"
      preLoaderRoute: typeof appWorkspaceSettingsCustomFieldsRouteImport
      parentRoute: typeof appWorkspaceSettingsRouteRoute
    }
    "/(app)/$workspace/settings/issue-sources": {
      id: "/(app)/$workspace/settings/issue-sources"
      path: "/issue-sources"
      fullPath: "/$workspace/settings/issue-sources"
      preLoaderRoute: typeof appWorkspaceSettingsIssueSourcesRouteImport
      parentRoute: typeof appWorkspaceSettingsRouteRoute
    }
    "/(app)/$workspace/settings/outcomes": {
      id: "/(app)/$workspace/settings/outcomes"
      path: "/outcomes"
      fullPath: "/$workspace/settings/outcomes"
      preLoaderRoute: typeof appWorkspaceSettingsOutcomesRouteImport
      parentRoute: typeof appWorkspaceSettingsRouteRoute
    }
    "/(app)/$workspace/settings/permissions": {
      id: "/(app)/$workspace/settings/permissions"
      path: "/permissions"
      fullPath: "/$workspace/settings/permissions"
      preLoaderRoute: typeof appWorkspaceSettingsPermissionsRouteImport
      parentRoute: typeof appWorkspaceSettingsRouteRoute
    }
    "/(app)/$workspace/settings/preferences": {
      id: "/(app)/$workspace/settings/preferences"
      path: "/preferences"
      fullPath: "/$workspace/settings/preferences"
      preLoaderRoute: typeof appWorkspaceSettingsPreferencesRouteImport
      parentRoute: typeof appWorkspaceSettingsRouteRoute
    }
    "/(app)/$workspace/settings/profile": {
      id: "/(app)/$workspace/settings/profile"
      path: "/profile"
      fullPath: "/$workspace/settings/profile"
      preLoaderRoute: typeof appWorkspaceSettingsProfileRouteImport
      parentRoute: typeof appWorkspaceSettingsRouteRoute
    }
    "/(app)/$workspace/settings/trash": {
      id: "/(app)/$workspace/settings/trash"
      path: "/trash"
      fullPath: "/$workspace/settings/trash"
      preLoaderRoute: typeof appWorkspaceSettingsTrashRouteImport
      parentRoute: typeof appWorkspaceSettingsRouteRoute
    }
    "/(app)/$workspace/settings/updates": {
      id: "/(app)/$workspace/settings/updates"
      path: "/updates"
      fullPath: "/$workspace/settings/updates"
      preLoaderRoute: typeof appWorkspaceSettingsUpdatesRouteImport
      parentRoute: typeof appWorkspaceSettingsRouteRoute
    }
    "/(app)/$workspace/settings/workspace": {
      id: "/(app)/$workspace/settings/workspace"
      path: "/workspace"
      fullPath: "/$workspace/settings/workspace"
      preLoaderRoute: typeof appWorkspaceSettingsWorkspaceRouteImport
      parentRoute: typeof appWorkspaceSettingsRouteRoute
    }
    "/(app)/$workspace/team/$teamId": {
      id: "/(app)/$workspace/team/$teamId"
      path: "/team/$teamId"
      fullPath: "/$workspace/team/$teamId"
      preLoaderRoute: typeof appWorkspaceTeamTeamIdRouteRouteImport
      parentRoute: typeof appWorkspaceRouteRoute
    }
    "/(app)/$workspace/workflow/$workflowId": {
      id: "/(app)/$workspace/workflow/$workflowId"
      path: "/workflow/$workflowId"
      fullPath: "/$workspace/workflow/$workflowId"
      preLoaderRoute: typeof appWorkspaceWorkflowWorkflowIdRouteRouteImport
      parentRoute: typeof appWorkspaceRouteRoute
    }
    "/(app)/$workspace/member/$memberId/": {
      id: "/(app)/$workspace/member/$memberId/"
      path: "/member/$memberId"
      fullPath: "/$workspace/member/$memberId/"
      preLoaderRoute: typeof appWorkspaceMemberMemberIdIndexRouteImport
      parentRoute: typeof appWorkspaceRouteRoute
    }
    "/(app)/$workspace/settings/access/": {
      id: "/(app)/$workspace/settings/access/"
      path: "/access"
      fullPath: "/$workspace/settings/access/"
      preLoaderRoute: typeof appWorkspaceSettingsAccessIndexRouteImport
      parentRoute: typeof appWorkspaceSettingsRouteRoute
    }
    "/(app)/$workspace/settings/access/create": {
      id: "/(app)/$workspace/settings/access/create"
      path: "/access/create"
      fullPath: "/$workspace/settings/access/create"
      preLoaderRoute: typeof appWorkspaceSettingsAccessCreateRouteImport
      parentRoute: typeof appWorkspaceSettingsRouteRoute
    }
    "/(app)/$workspace/settings/api/": {
      id: "/(app)/$workspace/settings/api/"
      path: "/api"
      fullPath: "/$workspace/settings/api/"
      preLoaderRoute: typeof appWorkspaceSettingsApiIndexRouteImport
      parentRoute: typeof appWorkspaceSettingsRouteRoute
    }
    "/(app)/$workspace/settings/issue-types/": {
      id: "/(app)/$workspace/settings/issue-types/"
      path: "/issue-types"
      fullPath: "/$workspace/settings/issue-types/"
      preLoaderRoute: typeof appWorkspaceSettingsIssueTypesIndexRouteImport
      parentRoute: typeof appWorkspaceSettingsRouteRoute
    }
    "/(app)/$workspace/settings/issue-types/$issueTypeId": {
      id: "/(app)/$workspace/settings/issue-types/$issueTypeId"
      path: "/issue-types/$issueTypeId"
      fullPath: "/$workspace/settings/issue-types/$issueTypeId"
      preLoaderRoute: typeof appWorkspaceSettingsIssueTypesIssueTypeIdRouteImport
      parentRoute: typeof appWorkspaceSettingsRouteRoute
    }
    "/(app)/$workspace/settings/members/": {
      id: "/(app)/$workspace/settings/members/"
      path: "/members"
      fullPath: "/$workspace/settings/members/"
      preLoaderRoute: typeof appWorkspaceSettingsMembersIndexRouteImport
      parentRoute: typeof appWorkspaceSettingsRouteRoute
    }
    "/(app)/$workspace/settings/members/$userId": {
      id: "/(app)/$workspace/settings/members/$userId"
      path: "/members/$userId"
      fullPath: "/$workspace/settings/members/$userId"
      preLoaderRoute: typeof appWorkspaceSettingsMembersUserIdRouteImport
      parentRoute: typeof appWorkspaceSettingsRouteRoute
    }
    "/(app)/$workspace/settings/teams/": {
      id: "/(app)/$workspace/settings/teams/"
      path: "/teams"
      fullPath: "/$workspace/settings/teams/"
      preLoaderRoute: typeof appWorkspaceSettingsTeamsIndexRouteImport
      parentRoute: typeof appWorkspaceSettingsRouteRoute
    }
    "/(app)/$workspace/settings/workflows/": {
      id: "/(app)/$workspace/settings/workflows/"
      path: "/workflows"
      fullPath: "/$workspace/settings/workflows/"
      preLoaderRoute: typeof appWorkspaceSettingsWorkflowsIndexRouteImport
      parentRoute: typeof appWorkspaceSettingsRouteRoute
    }
    "/(app)/$workspace/team/$teamId/": {
      id: "/(app)/$workspace/team/$teamId/"
      path: "/"
      fullPath: "/$workspace/team/$teamId/"
      preLoaderRoute: typeof appWorkspaceTeamTeamIdIndexRouteImport
      parentRoute: typeof appWorkspaceTeamTeamIdRouteRoute
    }
    "/(app)/$workspace/team/$teamId/board": {
      id: "/(app)/$workspace/team/$teamId/board"
      path: "/board"
      fullPath: "/$workspace/team/$teamId/board"
      preLoaderRoute: typeof appWorkspaceTeamTeamIdBoardRouteImport
      parentRoute: typeof appWorkspaceTeamTeamIdRouteRoute
    }
    "/(app)/$workspace/team/$teamId/chart": {
      id: "/(app)/$workspace/team/$teamId/chart"
      path: "/chart"
      fullPath: "/$workspace/team/$teamId/chart"
      preLoaderRoute: typeof appWorkspaceTeamTeamIdChartRouteImport
      parentRoute: typeof appWorkspaceTeamTeamIdRouteRoute
    }
    "/(app)/$workspace/team/$teamId/list": {
      id: "/(app)/$workspace/team/$teamId/list"
      path: "/list"
      fullPath: "/$workspace/team/$teamId/list"
      preLoaderRoute: typeof appWorkspaceTeamTeamIdListRouteImport
      parentRoute: typeof appWorkspaceTeamTeamIdRouteRoute
    }
    "/(app)/$workspace/team/$teamId/members": {
      id: "/(app)/$workspace/team/$teamId/members"
      path: "/members"
      fullPath: "/$workspace/team/$teamId/members"
      preLoaderRoute: typeof appWorkspaceTeamTeamIdMembersRouteImport
      parentRoute: typeof appWorkspaceTeamTeamIdRouteRoute
    }
    "/(app)/$workspace/team/$teamId/overview": {
      id: "/(app)/$workspace/team/$teamId/overview"
      path: "/overview"
      fullPath: "/$workspace/team/$teamId/overview"
      preLoaderRoute: typeof appWorkspaceTeamTeamIdOverviewRouteImport
      parentRoute: typeof appWorkspaceTeamTeamIdRouteRoute
    }
    "/(app)/$workspace/workflow/$workflowId/": {
      id: "/(app)/$workspace/workflow/$workflowId/"
      path: "/"
      fullPath: "/$workspace/workflow/$workflowId/"
      preLoaderRoute: typeof appWorkspaceWorkflowWorkflowIdIndexRouteImport
      parentRoute: typeof appWorkspaceWorkflowWorkflowIdRouteRoute
    }
    "/(app)/$workspace/workflow/$workflowId/board": {
      id: "/(app)/$workspace/workflow/$workflowId/board"
      path: "/board"
      fullPath: "/$workspace/workflow/$workflowId/board"
      preLoaderRoute: typeof appWorkspaceWorkflowWorkflowIdBoardRouteImport
      parentRoute: typeof appWorkspaceWorkflowWorkflowIdRouteRoute
    }
    "/(app)/$workspace/workflow/$workflowId/dashboard": {
      id: "/(app)/$workspace/workflow/$workflowId/dashboard"
      path: "/dashboard"
      fullPath: "/$workspace/workflow/$workflowId/dashboard"
      preLoaderRoute: typeof appWorkspaceWorkflowWorkflowIdDashboardRouteImport
      parentRoute: typeof appWorkspaceWorkflowWorkflowIdRouteRoute
    }
    "/(app)/$workspace/workflow/$workflowId/list": {
      id: "/(app)/$workspace/workflow/$workflowId/list"
      path: "/list"
      fullPath: "/$workspace/workflow/$workflowId/list"
      preLoaderRoute: typeof appWorkspaceWorkflowWorkflowIdListRouteImport
      parentRoute: typeof appWorkspaceWorkflowWorkflowIdRouteRoute
    }
    "/(app)/$workspace/settings/access/$apiKeyId/": {
      id: "/(app)/$workspace/settings/access/$apiKeyId/"
      path: "/access/$apiKeyId"
      fullPath: "/$workspace/settings/access/$apiKeyId/"
      preLoaderRoute: typeof appWorkspaceSettingsAccessApiKeyIdIndexRouteImport
      parentRoute: typeof appWorkspaceSettingsRouteRoute
    }
    "/(app)/$workspace/settings/access/$apiKeyId/edit": {
      id: "/(app)/$workspace/settings/access/$apiKeyId/edit"
      path: "/access/$apiKeyId/edit"
      fullPath: "/$workspace/settings/access/$apiKeyId/edit"
      preLoaderRoute: typeof appWorkspaceSettingsAccessApiKeyIdEditRouteImport
      parentRoute: typeof appWorkspaceSettingsRouteRoute
    }
    "/(app)/$workspace/settings/api/keys/create": {
      id: "/(app)/$workspace/settings/api/keys/create"
      path: "/api/keys/create"
      fullPath: "/$workspace/settings/api/keys/create"
      preLoaderRoute: typeof appWorkspaceSettingsApiKeysCreateRouteImport
      parentRoute: typeof appWorkspaceSettingsRouteRoute
    }
    "/(app)/$workspace/settings/api/webhooks/create": {
      id: "/(app)/$workspace/settings/api/webhooks/create"
      path: "/api/webhooks/create"
      fullPath: "/$workspace/settings/api/webhooks/create"
      preLoaderRoute: typeof appWorkspaceSettingsApiWebhooksCreateRouteImport
      parentRoute: typeof appWorkspaceSettingsRouteRoute
    }
    "/(app)/$workspace/settings/teams/$teamId/": {
      id: "/(app)/$workspace/settings/teams/$teamId/"
      path: "/teams/$teamId"
      fullPath: "/$workspace/settings/teams/$teamId/"
      preLoaderRoute: typeof appWorkspaceSettingsTeamsTeamIdIndexRouteImport
      parentRoute: typeof appWorkspaceSettingsRouteRoute
    }
    "/(app)/$workspace/settings/workflows/$workflowId/": {
      id: "/(app)/$workspace/settings/workflows/$workflowId/"
      path: "/workflows/$workflowId"
      fullPath: "/$workspace/settings/workflows/$workflowId/"
      preLoaderRoute: typeof appWorkspaceSettingsWorkflowsWorkflowIdIndexRouteImport
      parentRoute: typeof appWorkspaceSettingsRouteRoute
    }
    "/(app)/$workspace/workflow/$workflowId/view/$viewId": {
      id: "/(app)/$workspace/workflow/$workflowId/view/$viewId"
      path: "/view/$viewId"
      fullPath: "/$workspace/workflow/$workflowId/view/$viewId"
      preLoaderRoute: typeof appWorkspaceWorkflowWorkflowIdViewViewIdRouteImport
      parentRoute: typeof appWorkspaceWorkflowWorkflowIdRouteRoute
    }
    "/(app)/$workspace/settings/api/keys/$apiKeyId/": {
      id: "/(app)/$workspace/settings/api/keys/$apiKeyId/"
      path: "/api/keys/$apiKeyId"
      fullPath: "/$workspace/settings/api/keys/$apiKeyId/"
      preLoaderRoute: typeof appWorkspaceSettingsApiKeysApiKeyIdIndexRouteImport
      parentRoute: typeof appWorkspaceSettingsRouteRoute
    }
    "/(app)/$workspace/settings/api/keys/$apiKeyId/edit": {
      id: "/(app)/$workspace/settings/api/keys/$apiKeyId/edit"
      path: "/api/keys/$apiKeyId/edit"
      fullPath: "/$workspace/settings/api/keys/$apiKeyId/edit"
      preLoaderRoute: typeof appWorkspaceSettingsApiKeysApiKeyIdEditRouteImport
      parentRoute: typeof appWorkspaceSettingsRouteRoute
    }
    "/(app)/$workspace/settings/api/webhooks/$webhookId/": {
      id: "/(app)/$workspace/settings/api/webhooks/$webhookId/"
      path: "/api/webhooks/$webhookId"
      fullPath: "/$workspace/settings/api/webhooks/$webhookId/"
      preLoaderRoute: typeof appWorkspaceSettingsApiWebhooksWebhookIdIndexRouteImport
      parentRoute: typeof appWorkspaceSettingsRouteRoute
    }
    "/(app)/$workspace/settings/api/webhooks/$webhookId/edit": {
      id: "/(app)/$workspace/settings/api/webhooks/$webhookId/edit"
      path: "/api/webhooks/$webhookId/edit"
      fullPath: "/$workspace/settings/api/webhooks/$webhookId/edit"
      preLoaderRoute: typeof appWorkspaceSettingsApiWebhooksWebhookIdEditRouteImport
      parentRoute: typeof appWorkspaceSettingsRouteRoute
    }
  }
}

interface appWorkspaceSettingsRouteRouteChildren {
  appWorkspaceSettingsAppearanceRoute: typeof appWorkspaceSettingsAppearanceRoute
  appWorkspaceSettingsCustomFieldsRoute: typeof appWorkspaceSettingsCustomFieldsRoute
  appWorkspaceSettingsIssueSourcesRoute: typeof appWorkspaceSettingsIssueSourcesRoute
  appWorkspaceSettingsOutcomesRoute: typeof appWorkspaceSettingsOutcomesRoute
  appWorkspaceSettingsPermissionsRoute: typeof appWorkspaceSettingsPermissionsRoute
  appWorkspaceSettingsPreferencesRoute: typeof appWorkspaceSettingsPreferencesRoute
  appWorkspaceSettingsProfileRoute: typeof appWorkspaceSettingsProfileRoute
  appWorkspaceSettingsTrashRoute: typeof appWorkspaceSettingsTrashRoute
  appWorkspaceSettingsUpdatesRoute: typeof appWorkspaceSettingsUpdatesRoute
  appWorkspaceSettingsWorkspaceRoute: typeof appWorkspaceSettingsWorkspaceRoute
  appWorkspaceSettingsIndexRoute: typeof appWorkspaceSettingsIndexRoute
  appWorkspaceSettingsAccessCreateRoute: typeof appWorkspaceSettingsAccessCreateRoute
  appWorkspaceSettingsIssueTypesIssueTypeIdRoute: typeof appWorkspaceSettingsIssueTypesIssueTypeIdRoute
  appWorkspaceSettingsMembersUserIdRoute: typeof appWorkspaceSettingsMembersUserIdRoute
  appWorkspaceSettingsAccessIndexRoute: typeof appWorkspaceSettingsAccessIndexRoute
  appWorkspaceSettingsApiIndexRoute: typeof appWorkspaceSettingsApiIndexRoute
  appWorkspaceSettingsIssueTypesIndexRoute: typeof appWorkspaceSettingsIssueTypesIndexRoute
  appWorkspaceSettingsMembersIndexRoute: typeof appWorkspaceSettingsMembersIndexRoute
  appWorkspaceSettingsTeamsIndexRoute: typeof appWorkspaceSettingsTeamsIndexRoute
  appWorkspaceSettingsWorkflowsIndexRoute: typeof appWorkspaceSettingsWorkflowsIndexRoute
  appWorkspaceSettingsAccessApiKeyIdEditRoute: typeof appWorkspaceSettingsAccessApiKeyIdEditRoute
  appWorkspaceSettingsApiKeysCreateRoute: typeof appWorkspaceSettingsApiKeysCreateRoute
  appWorkspaceSettingsApiWebhooksCreateRoute: typeof appWorkspaceSettingsApiWebhooksCreateRoute
  appWorkspaceSettingsAccessApiKeyIdIndexRoute: typeof appWorkspaceSettingsAccessApiKeyIdIndexRoute
  appWorkspaceSettingsTeamsTeamIdIndexRoute: typeof appWorkspaceSettingsTeamsTeamIdIndexRoute
  appWorkspaceSettingsWorkflowsWorkflowIdIndexRoute: typeof appWorkspaceSettingsWorkflowsWorkflowIdIndexRoute
  appWorkspaceSettingsApiKeysApiKeyIdEditRoute: typeof appWorkspaceSettingsApiKeysApiKeyIdEditRoute
  appWorkspaceSettingsApiWebhooksWebhookIdEditRoute: typeof appWorkspaceSettingsApiWebhooksWebhookIdEditRoute
  appWorkspaceSettingsApiKeysApiKeyIdIndexRoute: typeof appWorkspaceSettingsApiKeysApiKeyIdIndexRoute
  appWorkspaceSettingsApiWebhooksWebhookIdIndexRoute: typeof appWorkspaceSettingsApiWebhooksWebhookIdIndexRoute
}

const appWorkspaceSettingsRouteRouteChildren: appWorkspaceSettingsRouteRouteChildren =
  {
    appWorkspaceSettingsAppearanceRoute: appWorkspaceSettingsAppearanceRoute,
    appWorkspaceSettingsCustomFieldsRoute:
      appWorkspaceSettingsCustomFieldsRoute,
    appWorkspaceSettingsIssueSourcesRoute:
      appWorkspaceSettingsIssueSourcesRoute,
    appWorkspaceSettingsOutcomesRoute: appWorkspaceSettingsOutcomesRoute,
    appWorkspaceSettingsPermissionsRoute: appWorkspaceSettingsPermissionsRoute,
    appWorkspaceSettingsPreferencesRoute: appWorkspaceSettingsPreferencesRoute,
    appWorkspaceSettingsProfileRoute: appWorkspaceSettingsProfileRoute,
    appWorkspaceSettingsTrashRoute: appWorkspaceSettingsTrashRoute,
    appWorkspaceSettingsUpdatesRoute: appWorkspaceSettingsUpdatesRoute,
    appWorkspaceSettingsWorkspaceRoute: appWorkspaceSettingsWorkspaceRoute,
    appWorkspaceSettingsIndexRoute: appWorkspaceSettingsIndexRoute,
    appWorkspaceSettingsAccessCreateRoute:
      appWorkspaceSettingsAccessCreateRoute,
    appWorkspaceSettingsIssueTypesIssueTypeIdRoute:
      appWorkspaceSettingsIssueTypesIssueTypeIdRoute,
    appWorkspaceSettingsMembersUserIdRoute:
      appWorkspaceSettingsMembersUserIdRoute,
    appWorkspaceSettingsAccessIndexRoute: appWorkspaceSettingsAccessIndexRoute,
    appWorkspaceSettingsApiIndexRoute: appWorkspaceSettingsApiIndexRoute,
    appWorkspaceSettingsIssueTypesIndexRoute:
      appWorkspaceSettingsIssueTypesIndexRoute,
    appWorkspaceSettingsMembersIndexRoute:
      appWorkspaceSettingsMembersIndexRoute,
    appWorkspaceSettingsTeamsIndexRoute: appWorkspaceSettingsTeamsIndexRoute,
    appWorkspaceSettingsWorkflowsIndexRoute:
      appWorkspaceSettingsWorkflowsIndexRoute,
    appWorkspaceSettingsAccessApiKeyIdEditRoute:
      appWorkspaceSettingsAccessApiKeyIdEditRoute,
    appWorkspaceSettingsApiKeysCreateRoute:
      appWorkspaceSettingsApiKeysCreateRoute,
    appWorkspaceSettingsApiWebhooksCreateRoute:
      appWorkspaceSettingsApiWebhooksCreateRoute,
    appWorkspaceSettingsAccessApiKeyIdIndexRoute:
      appWorkspaceSettingsAccessApiKeyIdIndexRoute,
    appWorkspaceSettingsTeamsTeamIdIndexRoute:
      appWorkspaceSettingsTeamsTeamIdIndexRoute,
    appWorkspaceSettingsWorkflowsWorkflowIdIndexRoute:
      appWorkspaceSettingsWorkflowsWorkflowIdIndexRoute,
    appWorkspaceSettingsApiKeysApiKeyIdEditRoute:
      appWorkspaceSettingsApiKeysApiKeyIdEditRoute,
    appWorkspaceSettingsApiWebhooksWebhookIdEditRoute:
      appWorkspaceSettingsApiWebhooksWebhookIdEditRoute,
    appWorkspaceSettingsApiKeysApiKeyIdIndexRoute:
      appWorkspaceSettingsApiKeysApiKeyIdIndexRoute,
    appWorkspaceSettingsApiWebhooksWebhookIdIndexRoute:
      appWorkspaceSettingsApiWebhooksWebhookIdIndexRoute,
  }

const appWorkspaceSettingsRouteRouteWithChildren =
  appWorkspaceSettingsRouteRoute._addFileChildren(
    appWorkspaceSettingsRouteRouteChildren,
  )

interface appWorkspaceTeamTeamIdRouteRouteChildren {
  appWorkspaceTeamTeamIdBoardRoute: typeof appWorkspaceTeamTeamIdBoardRoute
  appWorkspaceTeamTeamIdChartRoute: typeof appWorkspaceTeamTeamIdChartRoute
  appWorkspaceTeamTeamIdListRoute: typeof appWorkspaceTeamTeamIdListRoute
  appWorkspaceTeamTeamIdMembersRoute: typeof appWorkspaceTeamTeamIdMembersRoute
  appWorkspaceTeamTeamIdOverviewRoute: typeof appWorkspaceTeamTeamIdOverviewRoute
  appWorkspaceTeamTeamIdIndexRoute: typeof appWorkspaceTeamTeamIdIndexRoute
}

const appWorkspaceTeamTeamIdRouteRouteChildren: appWorkspaceTeamTeamIdRouteRouteChildren =
  {
    appWorkspaceTeamTeamIdBoardRoute: appWorkspaceTeamTeamIdBoardRoute,
    appWorkspaceTeamTeamIdChartRoute: appWorkspaceTeamTeamIdChartRoute,
    appWorkspaceTeamTeamIdListRoute: appWorkspaceTeamTeamIdListRoute,
    appWorkspaceTeamTeamIdMembersRoute: appWorkspaceTeamTeamIdMembersRoute,
    appWorkspaceTeamTeamIdOverviewRoute: appWorkspaceTeamTeamIdOverviewRoute,
    appWorkspaceTeamTeamIdIndexRoute: appWorkspaceTeamTeamIdIndexRoute,
  }

const appWorkspaceTeamTeamIdRouteRouteWithChildren =
  appWorkspaceTeamTeamIdRouteRoute._addFileChildren(
    appWorkspaceTeamTeamIdRouteRouteChildren,
  )

interface appWorkspaceWorkflowWorkflowIdRouteRouteChildren {
  appWorkspaceWorkflowWorkflowIdBoardRoute: typeof appWorkspaceWorkflowWorkflowIdBoardRoute
  appWorkspaceWorkflowWorkflowIdDashboardRoute: typeof appWorkspaceWorkflowWorkflowIdDashboardRoute
  appWorkspaceWorkflowWorkflowIdListRoute: typeof appWorkspaceWorkflowWorkflowIdListRoute
  appWorkspaceWorkflowWorkflowIdIndexRoute: typeof appWorkspaceWorkflowWorkflowIdIndexRoute
  appWorkspaceWorkflowWorkflowIdViewViewIdRoute: typeof appWorkspaceWorkflowWorkflowIdViewViewIdRoute
}

const appWorkspaceWorkflowWorkflowIdRouteRouteChildren: appWorkspaceWorkflowWorkflowIdRouteRouteChildren =
  {
    appWorkspaceWorkflowWorkflowIdBoardRoute:
      appWorkspaceWorkflowWorkflowIdBoardRoute,
    appWorkspaceWorkflowWorkflowIdDashboardRoute:
      appWorkspaceWorkflowWorkflowIdDashboardRoute,
    appWorkspaceWorkflowWorkflowIdListRoute:
      appWorkspaceWorkflowWorkflowIdListRoute,
    appWorkspaceWorkflowWorkflowIdIndexRoute:
      appWorkspaceWorkflowWorkflowIdIndexRoute,
    appWorkspaceWorkflowWorkflowIdViewViewIdRoute:
      appWorkspaceWorkflowWorkflowIdViewViewIdRoute,
  }

const appWorkspaceWorkflowWorkflowIdRouteRouteWithChildren =
  appWorkspaceWorkflowWorkflowIdRouteRoute._addFileChildren(
    appWorkspaceWorkflowWorkflowIdRouteRouteChildren,
  )

interface appWorkspaceRouteRouteChildren {
  appWorkspaceSettingsRouteRoute: typeof appWorkspaceSettingsRouteRouteWithChildren
  appWorkspaceSplatRoute: typeof appWorkspaceSplatRoute
  appWorkspaceInboxRoute: typeof appWorkspaceInboxRoute
  appWorkspaceMapRoute: typeof appWorkspaceMapRoute
  appWorkspaceMembersRoute: typeof appWorkspaceMembersRoute
  appWorkspaceMyWorkRoute: typeof appWorkspaceMyWorkRoute
  appWorkspaceOrgChartRoute: typeof appWorkspaceOrgChartRoute
  appWorkspaceSharedRoute: typeof appWorkspaceSharedRoute
  appWorkspaceTeamsRoute: typeof appWorkspaceTeamsRoute
  appWorkspaceWorkflowsRoute: typeof appWorkspaceWorkflowsRoute
  appWorkspaceIndexRoute: typeof appWorkspaceIndexRoute
  appWorkspaceTeamTeamIdRouteRoute: typeof appWorkspaceTeamTeamIdRouteRouteWithChildren
  appWorkspaceWorkflowWorkflowIdRouteRoute: typeof appWorkspaceWorkflowWorkflowIdRouteRouteWithChildren
  appWorkspaceDashboardsViewIdRoute: typeof appWorkspaceDashboardsViewIdRoute
  appWorkspaceDashboardsMyRoute: typeof appWorkspaceDashboardsMyRoute
  appWorkspaceDashboardsIndexRoute: typeof appWorkspaceDashboardsIndexRoute
  appWorkspaceMemberMemberIdIndexRoute: typeof appWorkspaceMemberMemberIdIndexRoute
}

const appWorkspaceRouteRouteChildren: appWorkspaceRouteRouteChildren = {
  appWorkspaceSettingsRouteRoute: appWorkspaceSettingsRouteRouteWithChildren,
  appWorkspaceSplatRoute: appWorkspaceSplatRoute,
  appWorkspaceInboxRoute: appWorkspaceInboxRoute,
  appWorkspaceMapRoute: appWorkspaceMapRoute,
  appWorkspaceMembersRoute: appWorkspaceMembersRoute,
  appWorkspaceMyWorkRoute: appWorkspaceMyWorkRoute,
  appWorkspaceOrgChartRoute: appWorkspaceOrgChartRoute,
  appWorkspaceSharedRoute: appWorkspaceSharedRoute,
  appWorkspaceTeamsRoute: appWorkspaceTeamsRoute,
  appWorkspaceWorkflowsRoute: appWorkspaceWorkflowsRoute,
  appWorkspaceIndexRoute: appWorkspaceIndexRoute,
  appWorkspaceTeamTeamIdRouteRoute:
    appWorkspaceTeamTeamIdRouteRouteWithChildren,
  appWorkspaceWorkflowWorkflowIdRouteRoute:
    appWorkspaceWorkflowWorkflowIdRouteRouteWithChildren,
  appWorkspaceDashboardsViewIdRoute: appWorkspaceDashboardsViewIdRoute,
  appWorkspaceDashboardsMyRoute: appWorkspaceDashboardsMyRoute,
  appWorkspaceDashboardsIndexRoute: appWorkspaceDashboardsIndexRoute,
  appWorkspaceMemberMemberIdIndexRoute: appWorkspaceMemberMemberIdIndexRoute,
}

const appWorkspaceRouteRouteWithChildren =
  appWorkspaceRouteRoute._addFileChildren(appWorkspaceRouteRouteChildren)

interface appRouteRouteChildren {
  appWorkspaceRouteRoute: typeof appWorkspaceRouteRouteWithChildren
  appAdminRoute: typeof appAdminRoute
  appWorkspaceCreateRoute: typeof appWorkspaceCreateRoute
  appWorkspaceSelectRoute: typeof appWorkspaceSelectRoute
  appIndexRoute: typeof appIndexRoute
}

const appRouteRouteChildren: appRouteRouteChildren = {
  appWorkspaceRouteRoute: appWorkspaceRouteRouteWithChildren,
  appAdminRoute: appAdminRoute,
  appWorkspaceCreateRoute: appWorkspaceCreateRoute,
  appWorkspaceSelectRoute: appWorkspaceSelectRoute,
  appIndexRoute: appIndexRoute,
}

const appRouteRouteWithChildren = appRouteRoute._addFileChildren(
  appRouteRouteChildren,
)

interface authRouteRouteChildren {
  authAcceptInviteRoute: typeof authAcceptInviteRoute
  authForgotPasswordRoute: typeof authForgotPasswordRoute
  authLoginRoute: typeof authLoginRoute
  authRegisterRoute: typeof authRegisterRoute
  authResetPasswordRoute: typeof authResetPasswordRoute
  authResetPasswordSentRoute: typeof authResetPasswordSentRoute
  authVerifyEmailRoute: typeof authVerifyEmailRoute
  authVerifyEmailSentRoute: typeof authVerifyEmailSentRoute
}

const authRouteRouteChildren: authRouteRouteChildren = {
  authAcceptInviteRoute: authAcceptInviteRoute,
  authForgotPasswordRoute: authForgotPasswordRoute,
  authLoginRoute: authLoginRoute,
  authRegisterRoute: authRegisterRoute,
  authResetPasswordRoute: authResetPasswordRoute,
  authResetPasswordSentRoute: authResetPasswordSentRoute,
  authVerifyEmailRoute: authVerifyEmailRoute,
  authVerifyEmailSentRoute: authVerifyEmailSentRoute,
}

const authRouteRouteWithChildren = authRouteRoute._addFileChildren(
  authRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  appRouteRoute: appRouteRouteWithChildren,
  authRouteRoute: authRouteRouteWithChildren,
  LogoutRoute: LogoutRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
